import {observable, action} from 'mobx';
import io from 'socket.io-client';
import {cmURL} from '../libs/config'

// const socket = io.connect('http://hydrology.gov.np', {path:'/cm/socket.io'});
let connectionURL = cmURL.replace('http://', '').split('/');
const socket = io.connect(`${window.location.origin.split('://')[0]}://${connectionURL[0]}`, {path: connectionURL[1] ? '/'+connectionURL[1]+'/socket.io' : ''});

class ContentStore {
  @observable notice = [];
  @observable news_events = [];
  @observable community_outreach = [];
  @observable projects = [];
  @observable publications = [];
  @observable important_links = [];
  @observable current_forecast = [];
  @observable alerts = [];

  constructor(transportLayer){
    this.transportLayer = transportLayer;

    this.fetch('notice');
    this.fetch('news_events');
    this.fetch('community_outreach');
    this.fetch('projects');
    this.fetch('publications');
    this.fetch('important_links');
    this.fetch('current_forecast');
    this.fetch('alerts');

    socket.on('notice', res => {
      console.log(res.message);
      setTimeout(() => this.fetch('notice'), 3000);
    });

    socket.on('news_events', message => {
      console.log(message.message);
      setTimeout(() => this.fetch('news_events'), 3000);
    });

    socket.on('community_outreach', message => {
      console.log(message.message);
      setTimeout(() => this.fetch('community_outreach'), 3000);
    });

    socket.on('projects', message => {
      console.log(message.message);
      setTimeout(() => this.fetch('projects'), 3000);
    });

    socket.on('publications', message => {
      console.log(message.message);
      setTimeout(() => this.fetch('publications'), 3000);
    });

    socket.on('important_links', message => {
      console.log(message.message);
      setTimeout(() => this.fetch('important_links'), 3000);
    });

    socket.on('current_forecast', message => {
      console.log(message.message);
      setTimeout(() => this.fetch('current_forecast'), 3000);
    });

    socket.on('alerts', message => {
      console.log(message.message);
      setTimeout(() => this.fetch('alerts'), 3000);
    });
  }

  @action fetch(path){
    this.transportLayer.fetch(path).then(res => res.json()).then(res => {
      switch (path){
        case 'notice': if(res.length>0) this.notice = res.sort((a,b) => a.published_date<b.published_date?1:-1); else this.notice = []; break;
        case 'news_events': if(res.length>0) this.news_events = res.sort((a,b) => a.published_date<b.published_date?1:-1); else this.news_events = []; break;
        case 'community_outreach': if(res.length>0) this.community_outreach = res.sort((a,b) => a.id<b.id?1:-1); else this.community_outreach = []; break;
        case 'projects': if(res.length>0) this.projects = res.sort((a,b) => a.id<b.id?1:-1); else this.projects = []; break;
        case 'publications': if(res.length>0) this.publications = res.sort((a,b) => a.id<b.id?1:-1); else this.publications = []; break;
        case 'important_links': if(res.length>0) this.important_links = res.sort((a,b) => a.id<b.id?1:-1); else this.important_links = []; break;
        case 'current_forecast': if(res.length>0) this.current_forecast = res.sort((a,b) => a.id<b.id?1:-1); else this.current_forecast = []; break;
        case 'alerts': if(res.length>0) this.alerts = res.sort((a,b) => a.id<b.id?1:-1); else this.alerts = []; break;
        default : console.log('balbla'); break;
      }
    });
  }

  static socketDisconnect(){
    socket.disconnect()
  }

}

export default ContentStore;



// WEBPACK FOOTER //
// ./src/store/ContentStore.js